const faqs = [
  {
    id: 1,
    heading: 'What AI solutions do you offer?',
    content: 'At our AI & IT Startup, we provide a range of AI solutions tailored to your business needs. Our services include machine learning, natural language processing, computer vision, and more. We leverage cutting-edge technology to help you enhance your operations and gain a competitive edge.',
  },
  {
    id: 2,
    heading: 'How can AI benefit my startup?',
    content: 'AI can transform your startup by automating repetitive tasks, analyzing large datasets for valuable insights, improving customer experiences, and optimizing decision-making processes. Our AI solutions are designed to empower your business and drive growth in the fast-paced tech industry.',
  },
  {
    id: 3,
    heading: 'How can I get started with your AI services?',
    content: "Getting started with our AI services is simple. Reach out to our team, and we'll schedule a consultation to understand your business goals and requirements. From there, we'll create a customized AI strategy and implementation plan to help your startup thrive in the AI-driven era.",
  },
  {
    id: 4,
    heading: 'What industries can benefit from AI solutions?',
    content: 'AI solutions have applications across various industries, including healthcare, finance, e-commerce, cybersecurity, and more. Regardless of your industry, our AI and IT expertise can be tailored to meet your specific needs and drive innovation within your sector.',
  },
  {
    id: 5,
    heading: 'What sets your AI startup apart?',
    content: 'Our AI & IT Startup stands out due to our commitment to innovation, deep technical expertise, and a client-centric approach. We focus on delivering practical AI solutions that drive real results for your business. Partner with us to embark on a transformative AI journey.',
  },
];

export default faqs;